import {
  CalendarBiLogger,
  createCalendarBiLogger,
} from '../bi/biLoggerFactory';
import {
  BusinessInfo,
  BusinessInfoBase,
  StaffMember,
} from '@wix/bookings-uou-types';
import {
  CalendarState,
  TFunction,
} from '../../components/BookingCalendar/controller';

import { CalendarApi } from '../../api/CalendarApi';
import { WixOOISDKAdapter } from '@wix/bookings-adapter-ooi-wix-sdk';
import { ControllerParams } from '@wix/yoshi-flow-editor';

export type CalendarContext = {
  wixSdkAdapter: WixOOISDKAdapter;
  biLogger: CalendarBiLogger;
  businessInfo: BusinessInfoBase;
  calendarApi: CalendarApi;
  settings: ControllerParams['flowAPI']['settings'];
  t: TFunction;
};

export function createCalendarContext({
  flowAPI,
  businessInfo,
  calendarApi,
  wixSdkAdapter,
  initialState,
}: {
  flowAPI: any;
  businessInfo: BusinessInfo;
  calendarApi: CalendarApi;
  wixSdkAdapter: WixOOISDKAdapter;
  initialState: CalendarState;
}): CalendarContext {
  const {
    settings,
    translations: { t },
  } = flowAPI;
  const biLogger = createCalendarBiLogger(
    flowAPI,
    initialState,
    wixSdkAdapter,
    businessInfo,
    settings,
  );

  return {
    wixSdkAdapter,
    biLogger,
    businessInfo,
    calendarApi,
    settings,
    t,
  };
}
